export const getCustomsLineItems = (lineItems, itemsCustomsInfo) => {
  return itemsCustomsInfo?.map(item => {
    const lineItemInfo = lineItems?.find(lineItem => lineItem.inventory_item_id === item.id)
    return {
      customsInfo: item,
      ...lineItemInfo,
    }
  })
}
